import Swiper from "swiper/bundle";

const swipers = () => {
  const swiperTimeline = document.querySelector(".swiper-timeline");
  if (swiperTimeline !== null) {
    new Swiper(swiperTimeline, {
      autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
      },
      slidesPerView: 1,
      speed: 500,
      breakpoints: {
        540: {
          slidesPerView: 2,
        },
        992: {
          slidesPerView: 3,
        },
        1280: {
          slidesPerView: 4,
        },
      },
      navigation: {
        nextEl: ".timeline-next",
        prevEl: ".timeline-prev",
      },
    });
  }

  const swiperTraject = document.querySelector(".swiper-traject");
  if (swiperTraject !== null) {
    new Swiper(swiperTraject, {
      slidesPerView: 1.2,
      spaceBetween: 20,
      speed: 500,
      breakpoints: {
        992: {
          slidesPerView: 2,
        },
      },
      navigation: {
        nextEl: ".traject-next",
        prevEl: ".traject-prev",
      },
    });
  }

  const swiperWorkAt = document.querySelector(".swiper-work-at");
  if (swiperWorkAt !== null) {
    new Swiper(swiperWorkAt, {
      slidesPerView: 1.2,
      spaceBetween: 20,
      speed: 500,
      breakpoints: {
        992: {
          slidesPerView: 2.7,
        },
      },
      navigation: {
        nextEl: ".work-at-next",
        prevEl: ".work-at-prev",
      },
    });
  }

  const swiperCulture = document.querySelector(".swiper-culture");
  if (swiperCulture !== null) {
    new Swiper(swiperCulture, {
      autoplay: {
        delay: 2000,
        stopOnLastSlide: false,
      },
      slidesPerView: 1,
      spaceBetween: 20,
      speed: 600,
      navigation: {
        nextEl: ".culture-next",
        prevEl: ".culture-prev",
      },
    });
  }

  const swiperLocations = document.querySelector(".swiper-locations");
  if (swiperLocations !== null) {
    new Swiper(swiperLocations, {
      slidesPerView: 1.2,
      spaceBetween: 20,
      speed: 600,
      breakpoints: {
        540: {
          slidesPerView: 2,
        },
        992: {
          slidesPerView: 2.5,
        },
      },
      navigation: {
        nextEl: ".locations-next",
        prevEl: ".locations-prev",
      },
    });
  }
};

export default swipers;
